import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
    gap: theme.spacing(2),
    backgroundColor: '#DC354529',
    padding: theme.spacing(1, 3),
    margin: theme.spacing(1),
    border: '1px solid #E83A4966',
    borderRadius: 2,
  },
  content: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
    gap: theme.spacing(2),
  },
  label: {
    fontSize: 14,
    fontWeight: 'bold',
  },
  dayCounter: {
    fontSize: 26,
    fontWeight: 'bold',
    color: '#DC3545',
  },
  overdue: {
    fontSize: 14,
    fontWeight: 'bold',
    color: '#DC3545',
  },
}))

export default styles
